import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["source", "scope", "existing", "canonical", "canonicalField", "summary", "submit"]
  static values = { sourceName: String }

  connect() {
    this.refresh()
  }

  refresh() {
    const sourceName = this.sourceTarget.value.trim()
    const existingSelected = this.existingTarget.value.length > 0
    const existingName = existingSelected
      ? this.existingTarget.options[this.existingTarget.selectedIndex].text.trim()
      : ""
    const canonicalName = this.canonicalTarget.value.trim()
    const destinationName = existingName || canonicalName
    const originalSource = sourceName === this.sourceNameValue
    const selectedScopes = this.scopeTargets.filter(scope => scope.checked)
    const selectedCount = selectedScopes.reduce((total, scope) => total + Number(scope.dataset.count), 0)
    const quantity = originalSource
      ? `${selectedCount} ${selectedCount === 1 ? "tag" : "tags"}`
      : "matching tags"
    const scopeDescription = selectedScopes.length === 1
      ? `in ${selectedScopes[0].dataset.channelTitle}`
      : `across ${selectedScopes.length} selected channels`

    this.canonicalTarget.disabled = existingSelected
    this.canonicalFieldTarget.hidden = existingSelected
    this.submitTarget.disabled = destinationName.length === 0 || selectedScopes.length === 0
    this.submitTarget.classList.toggle("opacity-50", this.submitTarget.disabled)

    if (selectedScopes.length === 0) {
      this.summaryTarget.textContent = "Choose at least one channel. Mixed-channel names are never changed globally."
      this.submitTarget.value = "Choose channel(s)"
      return
    }

    if (destinationName.length === 0) {
      this.summaryTarget.textContent = "Choose an existing instructor or enter a new canonical name."
      this.submitTarget.value = "Choose an instructor"
      return
    }

    if (existingSelected) {
      this.summaryTarget.textContent = `${quantity} labelled “${sourceName}” ${scopeDescription} will be linked to ${existingName}.`
      this.submitTarget.value = `Link ${quantity} ${scopeDescription} to ${existingName}`
    } else {
      this.summaryTarget.textContent = `A new instructor, “${canonicalName}”, will be created and ${quantity} labelled “${sourceName}” ${scopeDescription} will be linked to it.`
      this.submitTarget.value = `Create ${canonicalName} and link ${quantity} ${scopeDescription}`
    }

    this.submitTarget.dataset.turboConfirm = this.summaryTarget.textContent
  }
}
